import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/vender/myPackages";

export default class PackagesService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
